import { QueryKey } from "@tanstack/react-query";

import { FeedbackFrontend } from "@performyard/service-contracts";

import { type CompanyFeedbackStreamFilters, companyFeedbackStream } from "../../services/defs/internal-api/feedback";

export const companyFeedbackStreamQuery = (
	filters?: CompanyFeedbackStreamFilters,
	onChunk?: (chunk: { data: FeedbackFrontend[] }) => void
) => {
	const queryKey: QueryKey = ["company-feedback", filters];
	// eslint-disable-next-line @tanstack/query/exhaustive-deps -- queryKey is the key itself; onChunk is a callback that shouldn't trigger refetches
	return {
		queryKey,
		queryFn: () => companyFeedbackStream(queryKey, filters, onChunk),
		meta: {
			errorMessage: "There was an error getting the company feedback.",
		},
		staleTime: Number.POSITIVE_INFINITY, // Don't refetch the data (because it's massive and we don't want to refetch it)
		gcTime: 30 * 1000, // Garbage collect the data 30 seconds after page leave
	};
};
